module.exports = __webpack_public_path__ + "static/media/i_love_you.2abccd6d.png";